import { Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

const Notfound = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <img src="/assets/404.svg" alt="icon" style={{ marginLeft: '6rem' }} />
        <br />
        <img src="/assets/oop.svg" alt="icon" />
        <br />
        <img src="/assets/Robot.svg" alt="icon" />
        <Button
          style={{
            marginLeft: '6rem',
            width: '238px',
            height: '56px',
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
            marginTop: '2rem',
            color: '#0e3063',
            fontSize: '20px',
          }}
          onClick={() => navigate(-1)}
        >
          Take me back
        </Button>
      </Space>
    </div>
  );
};

export default Notfound;
